import type { UpcomingPage } from "../types/content";

export const company = {
  name: "Hydréa",
  phone: "04 78 12 34 56",
  phoneHref: "tel:+33478123456",
  email: "contact@hydrea-plomberie.fr",
  address: "12 rue des Artisans, 69003 Lyon",
  hours: "Lun – Sam · 7h30 – 19h",
};

export const upcomingPages: UpcomingPage[] = [
  {
    path: "/services",
    label: "Services",
    title: "Nos services",
    planned: [
      "Fiche détaillée pour chaque prestation",
      "Marques et équipements installés",
      "Aides financières (MaPrimeRénov', CEE)",
    ],
  },
  {
    path: "/realisations",
    label: "Réalisations",
    title: "Nos réalisations",
    planned: [
      "Galerie de chantiers avant / après",
      "Filtres par type de travaux",
      "Études de cas détaillées",
    ],
  },
  {
    path: "/a-propos",
    label: "À propos",
    title: "À propos d'Hydréa",
    planned: [
      "Histoire et valeurs de l'entreprise",
      "Présentation de l'équipe",
      "Certifications et assurances",
    ],
  },
  {
    path: "/contact",
    label: "Contact",
    title: "Contact & devis",
    planned: [
      "Formulaire de demande de devis en ligne",
      "Carte de la zone d'intervention",
      "Prise de rendez-vous",
    ],
  },
];
